<div class="header">
  <a href="https://domowy.ceo.org.pl/" target="_blank">
    <img src="https://domowy.ceo.org.pl/wp-content/uploads/2020/06/DoM-2020_logo-bez-t%C5%82a-1024x334.png">
  </a>
</div>
<app-header></app-header>
<router-outlet></router-outlet>
<app-save-word></app-save-word>
<app-footer></app-footer>